/* t7-2a remate 2 (#529): EL TIPO DE UN MATERIAL, para pintar su icono (documento, video de
   YouTube o audio).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Funcion pura y neutra: la usan el Panel del alumno y el banco del profe. Decide SOLO con lo
   que el servidor ya manda (cero llamadas nuevas), en este orden:
     1. el campo explicito de origen: `file_type` igual a "youtube" o "audio" (lo escribe el
        servidor al CREAR el documento, asi que existe mientras procesa) y, en el banco,
        `pi_media.tipo`;
     2. el id de un video de YouTube (`pi_media.video_id`, del banco);
     3. una extension de audio (`EXTENSIONES_DE_AUDIO`, sin importar mayusculas) en el propio
        `file_type` o al final del nombre original (`pi_media.filename`, `original_filename`,
        `filename`);
     4. si no, documento: tambien un documento viejo que no trae ningun dato. */

export const TIPOS_DE_MATERIAL = ['documento', 'youtube', 'audio'];
export const EXTENSIONES_DE_AUDIO = ['mp3', 'm4a', 'wav', 'ogg', 'aac'];

const HABLADOS = ['youtube', 'audio'];

const minusculas = (valor) => (typeof valor === 'string' ? valor.trim().toLowerCase() : '');

/* La extension es lo que va despues del ULTIMO punto del nombre. */
const extensionDe = (nombre) => {
  const n = minusculas(nombre);
  const punto = n.lastIndexOf('.');
  return punto < 0 ? '' : n.slice(punto + 1);
};

export function tipoDeMaterial(doc) {
  const origen = minusculas(doc?.file_type);
  if (HABLADOS.includes(origen)) return origen;
  const media = doc?.pi_media || {};
  const delMedia = minusculas(media.tipo);
  if (HABLADOS.includes(delMedia)) return delMedia;
  if (minusculas(media.video_id)) return 'youtube';
  if (EXTENSIONES_DE_AUDIO.includes(origen)) return 'audio';
  const nombres = [media.filename, doc?.original_filename, doc?.filename];
  if (nombres.some((nombre) => EXTENSIONES_DE_AUDIO.includes(extensionDe(nombre)))) return 'audio';
  return 'documento';
}
